import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Monitor = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Monitor' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M1,16 L23,16 L23,2 L1,2 L1,16 Z M5,22 L19,22 L5,22 Z M9,22 L15,22 L15,16 L9,16 L9,22 Z' />
  </StyledIcon>
);
